module.exports = __webpack_public_path__ + "media/components/assets/icons/star_rank/starEmpty-42978ba196f7c0f5ca5afdca8d0444dc.svg";